"use strict";
exports.__esModule = true;
exports.displayTokenValue = void 0;
var account_1 = require("../../account");
var currencies_1 = require("../../currencies");
var tokens_1 = require("./tokens");
var displayTokenValue = function (token) {
    return "".concat(token.name, " (#").concat((0, tokens_1.extractTokenId)(token.id), ")");
};
exports.displayTokenValue = displayTokenValue;
var getSendFields = function (transaction, status, account, addRecipient) {
    var estimatedFees = status.estimatedFees, amount = status.amount;
    var fields = [];
    fields.push({
        type: "text",
        label: "Type",
        value: account.type === "TokenAccount" ? "Asset xfer" : "Payment"
    });
    if (estimatedFees && !estimatedFees.isZero()) {
        fields.push({
            type: "fees",
            label: "Fee"
        });
    }
    if (addRecipient) {
        fields.push({
            type: "address",
            label: "Recipient",
            address: transaction.recipient
        });
    }
    if (account.type === "TokenAccount") {
        fields.push({
            type: "text",
            label: "Asset ID",
            value: (0, exports.displayTokenValue)(account.token)
        });
    }
    if (amount) {
        fields.push({
            type: "text",
            label: account.type === "TokenAccount" ? "Asset amt" : "Amount",
            value: (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(account), amount, {
                showCode: true,
                disableRounding: true
            })
        });
    }
    return fields;
};
function getDeviceTransactionConfig(_a) {
    var account = _a.account, transaction = _a.transaction, status = _a.status;
    var mode = transaction.mode, assetId = transaction.assetId;
    var estimatedFees = status.estimatedFees;
    var fields = [];
    switch (mode) {
        case "send":
            fields = getSendFields(transaction, status, account, false);
            break;
        case "claimReward":
            fields = getSendFields(transaction, status, account, true);
            break;
        case "optIn":
            fields.push({
                type: "text",
                label: "Type",
                value: "Asset xfer"
            });
            if (estimatedFees && !estimatedFees.isZero()) {
                fields.push({
                    type: "fees",
                    label: "Fee"
                });
            }
            if (assetId) {
                var token = (0, currencies_1.findTokenById)(assetId);
                fields.push({
                    type: "text",
                    label: "Asset ID",
                    value: token
                        ? (0, exports.displayTokenValue)(token)
                        : "#".concat((0, tokens_1.extractTokenId)(assetId))
                });
            }
            fields.push({
                type: "text",
                label: "Asset amt",
                value: "0"
            });
            break;
        default:
            break;
    }
    return fields;
}
exports["default"] = getDeviceTransactionConfig;
//# sourceMappingURL=deviceTransactionConfig.js.map